// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuListContent_root__uaqXS {
  background: #FFFFFF;
  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01), 0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09), 0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  min-width: 105px;
  overflow: hidden;
}
.MenuListContent_root__uaqXS > *:first-child {
  padding-top: 7px;
}
.MenuListContent_root__uaqXS > *:last-child {
  padding-bottom: 7px;
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/MenuList/MenuListContent/MenuListContent.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,uLAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,mBAAA;AADJ","sourcesContent":[".root {\n  background: #FFFFFF;\n  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01), 0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09), 0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 14px;\n  min-width: 105px;\n  overflow: hidden;\n\n\n  &>*:first-child {\n    padding-top: 7px;\n  }\n\n  &>*:last-child {\n    padding-bottom: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MenuListContent_root__uaqXS`
};
export default ___CSS_LOADER_EXPORT___;
